export enum ErrorSnackbarDataCy {
    SNACK_BAR = 'error-snack-bar'
}
